package com.starparty.app.astro0.renderers

import com.starparty.app.astro0.SP_Canvas
import com.starparty.app.astro0.SP_Paint
import com.starparty.app.astro0.celestialbodies.Orrery

object OrreryRenderer {

    fun paint(orrery: Orrery, labelType: Int, c: SP_Canvas, p: SP_Paint) {

        if (orrery.isShowingObjects) {
            val bodies = orrery.bodies
            for (b in orrery.distanceOrder) {
                val body = bodies[b]
                OrbitalBodyRenderer.paint(body, labelType, c, p)
            }
        }
    }

}